import Api from '@/services/Api'

const HEADERURL = 'cxc/cargos/';
const ACTION_AGREGAR_DETALLE = 'agregar_detalle';
const ACTION_ELIMINAR_DETALLE = 'eliminar_detalle';
const ACTION_APLICAR_ABONO = 'aplicar_abono';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_IMPRIMIR = 'imprimir';
const ACTION_ELIMINAR_APLICACION = 'eliminar_abono_aplicado';
const ACTION_AGREGAR_CONTABILIZACION = 'agregar_contabilizacion';
const ACTION_ENVIAR_FEL = 'enviar_fel';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    agregar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_DETALLE}/`, params);

    },

    eliminar_detalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ELIMINAR_DETALLE}/`, params);

    },

    eliminar_abono_aplicado(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ELIMINAR_APLICACION}/`, params);

    },

    aplicar_abono(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_APLICAR_ABONO}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },

    imprimir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_IMPRIMIR}/`);

    },


    agregar_contabilizacion(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_CONTABILIZACION}/`, params);

    },

    enviar_fel(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ENVIAR_FEL}/`);

    },

}